<template>
  <div id="userLayout"
       :class="['user-layout-wrapper']">
    <div class="top">
      <div class="j">
        <img @click="home" src="../assets/图层 42@2x.png"
             alt="" />
        <div class="img"></div>
      </div>
      <div class="i">
        <nav class="nav">
          <div v-if="navType == true">
            <el-popover placement="bottom"
                        width="400"
                        trigger="hover">
              <div>
                <ul>
                  <li style="font-size: 18px;" @click="naver(1)">
                    首页
                    <p class="list-top"></p>
                  </li>
                  <li  style="font-size: 18px;"  @click="naver(2)">
                    解决方案
                    <p class="list-top"></p>
                  </li>
                  <li style="font-size: 18px;"  @click="naver(3)">
                    合作伙伴
                    <p class="list-top"></p>
                  </li>
                  <li style="font-size: 18px;"  @click="naver(4)">
                    企业动态
                    <p class="list-top"></p>
                  </li>
                  <li style="font-size: 18px;"  @click="naver(5)">
                    关于我们
                    <p class="list-top"></p>
                  </li>
                </ul>
              </div>
              <img slot="reference"
                   class="icon-s-operation"
                   src="../assets/移动端-右上角-菜单icon.png"
                   alt="" />
              <!-- <i slot="reference"
                 class="el-icon-s-operation"></i> -->
            </el-popover>
          </div>
          <div class="nav-box"
               v-if="navType == false">
            <ul>
              <li @click="naver(1)"
                  :class="li1">
                首页
                <p :class="listTop1"></p>
              </li>
              <li @click="naver(2)"
                  :class="li2">
                解决方案
                <p :class="listTop2"></p>
              </li>
              <li @click="naver(3)"
                  :class="li3">
                合作伙伴
                <p :class="listTop3"></p>
              </li>
              <li @click="naver(4)"
                  :class="li4">
                企业动态
                <p :class="listTop4"></p>
              </li>
              <li @click="naver(5)"
                  :class="li5">
                关于我们
                <p :class="listTop5"></p>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      navType: false,
      screenWidth: null,
      listTop1: 'list-top',
      listTop2: 'list-top',
      listTop3: 'list-top',
      listTop4: 'list-top',
      listTop5: 'list-top',
      li1: 'li1',
      li2: 'li1',
      li3: 'li1',
      li4: 'li1',
      li5: 'li1',
    };
  },
  mounted () {
    //获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      // console.log('高度');
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  watch: {
    screenWidth: function (n) {
      if (n <= 1000) {
        this.navType = true;
        console.log("屏幕宽度小于1200了");
      } else {
        this.navType = false;
        // console.log('屏幕宽度没有小于1200')
      }
    },
    $route (to) {
      if (to.path == '/') {
        this.listTop1 = 'list-top1'
        this.li1 = 'li1'
      } else {
        this.listTop1 = 'list-top'
        this.li1 = 'li2'
      }
      if (to.path == '/Solution') {
        this.listTop2 = 'list-top1'
        this.li2 = 'li1'
      } else {
        this.listTop2 = 'list-top'
        this.li2 = 'li2'
      }
      if (to.path == '/cooperate') {
        this.listTop3 = 'list-top1'
        this.li3 = 'li1'
      } else {
        this.listTop3 = 'list-top'
        this.li3 = 'li2'
      }
      if (to.path == "/enterprise" || to.path == "/detail") {
        this.listTop4 = 'list-top1'
        this.li4 = 'li1'
      } else {
        this.listTop4 = 'list-top'
        this.li4 = 'li2'
      }
      if (to.path == "/AboutUs") {
        this.listTop5 = 'list-top1'
        this.li5 = 'li1'
      } else {
        this.listTop5 = 'list-top'
        this.li5 = 'li2'
      }
    },
  },
  methods: {
    naver (value) {
      console.log(value);
      if (value === 1) {
        this.$router.push("/");
      }
      if (value == 2) {
        this.$router.push("/Solution");
      }
      if (value === 3) {
        this.$router.push('/cooperate')
      }
      if (value === 4) {
        this.$router.push("/enterprise");
      }
      if (value == 5) {
        this.$router.push("/AboutUs");
      }
    },
    home(){
      this.$router.push("/")
    },
    // navButton () {
    //   this.navType = !this.navType
    //   console.log(this.navType)
    // }
  },
};
</script>
<!-- import nav from '../' -->
<style lang="less" scoped>
@media (min-width: 1024px) {
  .top {
    position: fixed;
    top: 0;
    width: 100%;
    height: 76px;
    background-color: rgba(0, 0, 0, 0.15);
    // opacity: 0.15;
    display: flex;
    z-index: 999;
    .j {
      width: 40%;
      margin: auto;
      img {
        // background: url("../assets/图层 42@2x.png");
        // background-image: ;
        margin-left: 180px;
        cursor: pointer;
        z-index: 200 !important;
        opacity: 2 !important;
        width: 175px;
        height: 39px;
        line-height: 66px;
      }
    }
    .i {
      width: 60%;
      .nav {
        .el-icon-s-operation {
          font-size: 50px;
          color: aliceblue;
          float: right;
          margin-right: 10px;
          margin-top: 5px;
        }
        width: 100%;
        .nav-box {
          width: 100%;

          ul {
            margin-left: -90px;
            display: flex;
            justify-content: center;
            align-items: center;
            list-style: none;
            .li1 {
              cursor: pointer;
              margin-top: 8px;
              margin-left: 30px;
              margin-right: 30px;
              // justify-content: flex-end;
              // align-items: center;
              color: rgb(255, 255, 255);
              z-index: 1;
              font-weight: bold;
              // border-top: 3px solid #000000;
              // .list-top {
              //   border-radius: 5px ;
              //   width: 21px;
              //   margin: 7px auto 0;
              //   border-top: 4px solid #ffffff;
              // }
              .list-top {
                border-radius: 5px;
                width: 21px;
                margin: 7px auto 0;
                // border-top: 4px solid #ffffff;
              }
              .list-top1 {
                border-radius: 5px;
                width: 21px;
                margin: 7px auto 0;
                border-top: 4px solid #ffffff;
              }
            }
            .li2 {
              cursor: pointer;
              margin-top: 5px;
              margin-left: 30px;
              margin-right: 30px;
              // justify-content: flex-end;
              // align-items: center;
              color: rgb(255, 255, 255);
              z-index: 1;
              // font-weight: bold;
              // border-top: 3px solid #000000;
              // .list-top {
              //   border-radius: 5px ;
              //   width: 21px;
              //   margin: 7px auto 0;
              //   border-top: 4px solid #ffffff;
              // }
              .list-top {
                border-radius: 5px;
                width: 21px;
                margin: 7px auto 0;
                // border-top: 4px solid #ffffff;
              }
              .list-top1 {
                border-radius: 5px;
                width: 21px;
                margin: 7px auto 0;
                border-top: 4px solid #ffffff;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .top {
    position: fixed;
    top: 0;
    width: 100%;
    height: 36px;
    background-color: rgba(0, 0, 0, 0.15);
    // opacity: 0.15;
    display: flex;
    z-index: 999;
    .j {
      width: 40%;
      margin: auto;
      img {
        // background: url("../assets/图层 42@2x.png");
        // background-image: ;
        z-index: 200 !important;
        opacity: 2 !important;
        width: 85px;
        height: 19px;
        line-height: 66px;
        cursor: pointer;
      }
    }
    .i {
      width: 60%;
      .nav {
        .icon-s-operation {
          width: 25px;
          height: 25px;
          color: aliceblue;
          float: right;
          margin-right: 20px;
          margin-top: 5px;
        }
        width: 100%;
        ul {
            // margin-left: -90px;
            display: flex;
            justify-content: center;
            align-items: center;
            list-style: none;
            li {
              margin-top: 10px;
              margin-left: 30px;
              margin-right: 30px;
              // justify-content: flex-end;
              // align-items: center;
              // color: rgb(255, 255, 255);
              z-index: 1;
              font-weight: bold;
              font-size: 18px;
              // border-top: 3px solid #000000;
              // .list-top {
              //   border-radius: 5px ;
              //   width: 21px;
              //   margin: 7px auto 0;
              //   border-top: 4px solid #ffffff;
              // }
              
            }
          }
      }
    }
  }
}
</style>
